import {createStoreAPI} from './CreateStoreAPIService'

const api = createStoreAPI({
    getBaseURL: () => {
        return `${process.env.REACT_APP_ADMIN_URL || 'https://admin-staging.merchize.com'}`
    }
})

export const getMerchizeLibrary = (params) => {
    const defaultParams = {
        limit: 16,
        page: 1,
    }

    const newParams = {...defaultParams, ...params}

    return api.makeAuthRequest({
        url: '/api/manager/designs',
        method: 'GET',
        params: newParams,
    })
}

export const getMerchizeCollections = (params) => {
    const defaultParams = {
        limit: 100,
        page: 1,
    }

    const newParams = {...defaultParams, ...params}

    return api.makeAuthRequest({
        url: '/api/manager/design-collections',
        method: 'GET',
        params: newParams,
    })
}